module.exports = __webpack_public_path__ + "img/1-12.54d1387c.png";